import { render, staticRenderFns } from "./iconDown.vue?vue&type=template&id=377ed4cd&scoped=true&"
import script from "./iconDown.vue?vue&type=script&lang=js&"
export * from "./iconDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ed4cd",
  null
  
)

export default component.exports